import React, { useState } from "react";
import { ListItem, ListItemText, Collapse, Box } from "@mui/material";
import { ExpandMore, ExpandLess } from "@mui/icons-material";
import { Link, useLocation } from "react-router-dom";

import { Menu } from "../../model/menu";

export interface SidebarItemProps {
  menu: Menu;
  mergedPath: string;
  padding?: number;
}

const SidebarItem: React.FC<SidebarItemProps> = ({ menu, mergedPath, padding }) => {
  /* hooks */
  const location = useLocation();
  const [open, setOpen] = useState(location.pathname.includes(menu.path));
  const { icon: Icon } = menu;
  const paddingValue = padding ?? 0;
  const fullPath = `${mergedPath}${menu.path}`;

  const isActive = location.pathname === fullPath || location.pathname.startsWith(fullPath + "/");

  return (
    <div>
      {menu.child ? (
        <Box>
          <ListItem button onClick={() => setOpen(!open)} sx={{ py: 1, pl: paddingValue }}>
            <Icon fontSize="small" style={{ marginRight: "5px" }} color="action" />
            <ListItemText primary={menu.name} />
            {open ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={open} timeout="auto" unmountOnExit>
            {menu.child.map((child, index) => (
              <SidebarItem
                key={`${index}-${child.name}`}
                menu={child}
                mergedPath={fullPath}
                padding={paddingValue + 4}
              />
            ))}
          </Collapse>
        </Box>
      ) : (
        <Link to={fullPath} style={{ color: "inherit", textDecoration: "inherit" }}>
          <div className={isActive ? "active-menu" : ""}>
            <ListItem button sx={{ py: 1, pl: paddingValue }}>
              <Icon fontSize="small" style={{ marginRight: "5px" }} color="action" />
              <ListItemText>{menu.name}</ListItemText>
            </ListItem>
          </div>
        </Link>
      )}
    </div>
  );
};

export default SidebarItem;
